import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const ACT_FETCH_REQUEST = 'ACT_FETCH_REQUEST'
export const ACT_FETCH_SUCCESS = 'ACT_FETCH_SUCCESS'
export const ACT_FETCH_FAILURE = 'ACT_FETCH_FAILURE'
export const ACT_CLEAR = 'ACT_CLEAR'

const normalizarTexto = valor => {
  if (typeof valor !== 'string') return ''
  return valor.trim()
}

const normalizarPlanos = planos => {
  if (!Array.isArray(planos)) {
    return []
  }

  return planos.map(item => ({
    id: item.idPlano,
    numeroPlano: item.numeroPlano,
    titulo: item.titulo,
    tipoPlano: item.tipo,
    ciclo: 'act',
    status: normalizarTexto(item.status),
    dataFinal: item.dataFinal,
    melhoriaPercentual: normalizarTexto(item.melhoriaPercentual),
    resultado: normalizarTexto(item.resultado),
    diasParaAtrasoCritico: item.diasParaAtrasoCritico,
    lojaNome: item.lojaNome,
    produtoNome: item.produtoNome
  }))
}

export const fetchAct = ({ empresaId, projetoId, idiomaId, dataInicial, dataFinal }) => {
  return async dispatch => {
    dispatch({ type: ACT_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/listaplanos', {
        empresaId,
        projetoId,
        idiomaId,
        tipoPlano: '',
        ciclo: 'act',
        dataInicial,
        dataFinal
      })

      const data = response?.data
      const planos = normalizarPlanos(data?.planos)

      dispatch({
        type: ACT_FETCH_SUCCESS,
        payload: {
          itens: planos,
          total: planos.length,
          filtros: {
            dataInicial,
            dataFinal
          }
        }
      })
    } catch (error) {
      dispatch({
        type: ACT_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar planos do ciclo Act.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearAct = () => ({
  type: ACT_CLEAR
})